// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media (max-width: 1024px) {
  .col-sm-1 {
    width: 8.33%;
  }
  .col-sm-2 {
    width: 16.66%;
  }
  .col-sm-3 {
    width: 25%;
  }
  .col-sm-4 {
    width: 33.33%;
  }
  .col-sm-5 {
    width: 41.66%;
  }
  .col-sm-6 {
    width: 50%;
  }
  .col-sm-7 {
    width: 58.33%;
  }
  .col-sm-8 {
    width: 66.66%;
  }
  .col-sm-9 {
    width: 75%;
  }
  .col-sm-10 {
    width: 83.33%;
  }
  .col-sm-11 {
    width: 91.66%;
  }
  .col-sm-12 {
    width: 100%;
  }
  .col-sm-offset-1 {
    margin-left: 8.33%;
  }
  .col-sm-offset-2 {
    margin-left: 16.66%;
  }
  .col-sm-offset-3 {
    margin-left: 25%;
  }
  .col-sm-offset-4 {
    margin-left: 33.33%;
  }
  .col-sm-offset-5 {
    margin-left: 41.66%;
  }
  .col-sm-offset-6 {
    margin-left: 50%;
  }
  .col-sm-offset-7 {
    margin-left: 58.33%;
  }
  .col-sm-offset-8 {
    margin-left: 66.66%;
  }
  .col-sm-offset-9 {
    margin-left: 75%;
  }
  .col-sm-offset-10 {
    margin-left: 83.33%;
  }
  .col-sm-offset-11 {
    margin-left: 91.66%;
  }
  .col-sm-offset-12 {
    margin-left: 100%;
  }
}
@media (min-width: 1025px) {
  .col-md-1 {
    width: 8.33%;
  }
  .col-md-2 {
    width: 16.66%;
  }
  .col-md-3 {
    width: 25%;
  }
  .col-md-4 {
    width: 33.33%;
  }
  .col-md-5 {
    width: 41.66%;
  }
  .col-md-6 {
    width: 50%;
  }
  .col-md-7 {
    width: 58.33%;
  }
  .col-md-8 {
    width: 66.66%;
  }
  .col-md-9 {
    width: 75%;
  }
  .col-md-10 {
    width: 83.33%;
  }
  .col-md-11 {
    width: 91.66%;
  }
  .col-md-12 {
    width: 100%;
  }
  .col-md-offset-1 {
    margin-left: 8.33%;
  }
  .col-md-offset-2 {
    margin-left: 16.66%;
  }
  .col-md-offset-3 {
    margin-left: 25%;
  }
  .col-md-offset-4 {
    margin-left: 33.33%;
  }
  .col-md-offset-5 {
    margin-left: 41.66%;
  }
  .col-md-offset-6 {
    margin-left: 50%;
  }
  .col-md-offset-7 {
    margin-left: 58.33%;
  }
  .col-md-offset-8 {
    margin-left: 66.66%;
  }
  .col-md-offset-9 {
    margin-left: 75%;
  }
  .col-md-offset-10 {
    margin-left: 83.33%;
  }
  .col-md-offset-11 {
    margin-left: 91.66%;
  }
  .col-md-offset-12 {
    margin-left: 100%;
  }
}
.step-indicator {
  width: 80%;
  margin-left: 10%;
}

.main-div {
  margin-left: 18%;
  margin-right: 18%;
  margin-bottom: 20px;
  margin-top: 40px;
}
@media (max-width: 1024px) {
  .main-div {
    margin-left: 2.25%;
    margin-right: 2.25%;
    margin-top: 20%;
  }
}

.confirm-heading {
  font-size: 32px;
  color: #000000;
  opacity: 1;
  float: left;
  margin-bottom: 0px;
}
@media (max-width: 1024px) {
  .confirm-heading {
    line-height: 30px;
    font-size: 30px;
  }
}

.confirm-subheading {
  margin-top: 20px;
  margin-bottom: 5px;
}

.inline-success {
  display: inline-block;
  margin-right: 10px;
}
@media (max-width: 1024px) {
  .inline-success {
    display: table-cell;
    margin-right: 15px;
  }
}

.success-message {
  font-size: 24px;
  color: #067a3e;
  opacity: 1;
  margin-bottom: 10px;
}
@media (max-width: 1024px) {
  .success-message {
    line-height: 25px;
  }
}

.success-img {
  width: 60px;
  margin-bottom: 30px;
}
@media (min-width: 1025px) {
  .success-img {
    margin-top: -20px;
  }
}

.success-description {
  margin-top: -6px;
  margin-bottom: 0px;
}

.confirm-info {
  width: 100%;
  float: left;
  margin-top: 2%;
  margin-bottom: 2%;
}
@media (max-width: 1024px) {
  .confirm-info {
    width: 325px;
  }
}

.confirm-blocks {
  display: inline-block;
  margin-right: 10%;
}
@media (max-width: 1024px) {
  .confirm-blocks {
    margin-right: 9px;
  }
}

.confirm-block-heading {
  font-size: 16px;
  color: #000000;
  opacity: 1;
  text-align: left;
}
@media (max-width: 1024px) {
  .confirm-block-heading {
    width: 90px;
  }
}

.confirm-block-value {
  font-size: 24px;
  color: #000000;
  opacity: 1;
  text-align: left;
}
@media (max-width: 1024px) {
  .confirm-block-value {
    font-size: 16px;
  }
}

.contact-heading {
  margin-top: 2%;
  margin-bottom: 2%;
  font-size: 24px;
  color: #000000;
  opacity: 1;
  text-align: left;
}

.contact-section {
  width: 100%;
}

.added-links {
  display: inline-block;
  width: 40%;
}

.contact-fields {
  margin-bottom: 10px;
}

.prod-heading {
  font-size: 24px;
  color: #000000;
  opacity: 1;
  text-align: left;
}
@media (max-width: 1024px) {
  .prod-heading {
    line-height: 25px;
  }
}
@media (max-width: 1024px) {
  .prod-heading {
    margin-left: -30px;
  }
}

.notification-heading {
  font-size: 24px;
  color: #000000;
  opacity: 1;
  text-align: left;
}

.notification-section, .prod-section {
  margin-top: 2%;
}
.notification-section p, .prod-section p {
  margin-left: 15px;
}
@media (max-width: 1024px) {
  .notification-section p, .prod-section p {
    margin-left: -30px;
  }
}

.acknowledgement-sub-section {
  display: flexbox;
  background-color: #f2f2f2;
}

.acknowledgement-section {
  background-color: transparent;
}

.acknowledgement-heading {
  font-size: 24px;
  color: #000000;
  opacity: 1;
  padding: 15px 15px 15px 15px;
  margin-bottom: 0px;
}

.acknowledgement-description {
  font-size: 16px;
  color: #000000;
  opacity: 1;
  padding: 5px 15px 5px 15px;
  margin-bottom: 0px;
}

.confirm-section {
  padding: 15px 15px 15px 15px;
}
@media (max-width: 1024px) {
  .confirm-section {
    padding: 0px !important;
  }
}

#requestEnrollment {
  float: right;
  font-size: 17px;
  margin: 12px;
}
@media (max-width: 1024px) {
  #requestEnrollment {
    width: 235px;
  }
}
@media screen and (min-device-width: 414px) and (max-device-width: 736px) {
  #requestEnrollment {
    width: 265px;
  }
}

.requestEnrollment {
  color: #087ac2;
  font: 1.9rem "Omnes-ATT-W02-Medium";
  background: white;
  border: none;
}

#gotoApple {
  float: right;
  font-size: 17px;
  margin: 12px;
}
@media (max-width: 1024px) {
  #gotoApple {
    height: 55px;
  }
}

.confirm-subheading {
  font-size: 16px;
  color: #000000;
  opacity: 1;
  float: left;
}

a {
  color: #1483d9;
  cursor: pointer;
}

a:hover {
  text-decoration: underline;
}

#cancel-link {
  float: right;
  margin-right: 20px;
  margin-top: 15px;
  font-size: 18px;
}

.submit-section {
  height: 50px;
}
@media (max-width: 1024px) {
  .submit-section {
    height: 115px;
  }
}

.submit-section01 {
  height: 50px;
}
@media (max-width: 1024px) {
  .submit-section01 {
    height: 17rem;
  }
}

.labels-inline {
  display: inline-block;
}

.greybox {
  top: 469px;
  left: 215px;
  width: 945px;
  background: #F2F2F2 0% 0% no-repeat padding-box;
  opacity: 1;
  margin-bottom: 50px;
  padding: 15px;
}
@media (max-width: 1024px) {
  .greybox {
    width: 100%;
  }
}

.noteheading {
  font-weight: bold;
  font-size: 21px;
  text-align: center;
  font-family: normal normal medium 22px/21px ATT Aleck Sans;
  letter-spacing: 0.18px;
  color: #000000;
  opacity: 1;
}

.notetext {
  text-align: center;
}
@media (max-width: 1024px) {
  .notetext {
    word-wrap: break-word;
  }
}

.content-wrapper {
  position: relative;
  width: auto;
  padding: 15px 80px;
  margin: 0 auto;
}
@media (max-width: 1024px) {
  .content-wrapper {
    width: 230px !important;
    margin-left: 0px;
  }
}
@media (max-width: 1024px) {
  .content-wrapper {
    display: flex;
    flex-direction: row;
    padding: 0px;
    margin: 0 auto !important;
    width: 100% !important;
  }
}

.ng-modal-number-container {
  margin-top: 25px;
  background-color: #f1f2f3;
  width: auto;
  display: flex;
  display: -webkit-flex;
  justify-content: space-between;
  -webkit-justify-content: space-between;
}
@media (max-width: 1024px) {
  .ng-modal-number-container {
    flex-direction: column;
    border-top: 0px solid #1483d9;
    height: auto;
    width: 100%;
  }
}

.numberContainer {
  margin-top: -23px;
  position: relative;
  text-align: center;
}
@media (max-width: 1024px) {
  .numberContainer {
    display: flex;
  }
}

.ng-modal-number-container .numberContainer:last-child .numberIcon::after {
  display: none;
}

.numberIcon {
  margin: 0 auto 10px;
  width: 45px;
  height: 45px;
  border-radius: 50%;
  font-size: 18px;
  color: #f1f2f3;
  line-height: 42px;
  text-align: center;
  background: #1483d9;
  border: 2px solid #1483d9;
}
@media (max-width: 1024px) {
  .numberIcon {
    width: 32px;
    height: 32px;
    font-size: 16px;
    text-align: center;
    line-height: 32px;
    margin-left: 0px;
  }
}

.numberIcon::after {
  content: "";
  float: left;
  width: 100%;
  height: 4px;
  background-color: #1483d9;
  position: absolute;
  top: 19px;
  right: auto;
}
@media (max-width: 1024px) {
  .numberIcon::after {
    display: none;
  }
}

.content-text {
  position: relative;
  height: 185px;
  width: 630px;
  text-align: center;
  font-weight: bold;
}
@media (max-width: 1024px) {
  .content-text {
    height: 185px;
    width: 325px;
    text-align: center;
    font-weight: bold;
  }
}

.text-box {
  width: auto;
  display: flex;
  display: -webkit-flex;
  justify-content: space-between;
  -webkit-justify-content: space-between;
  margin-left: -70px;
  margin-top: 10px;
}
@media (max-width: 1024px) {
  .text-box {
    width: 220px;
    margin-left: -50px;
    margin: 20px 10px 10px 2px;
  }
}
@media (max-width: 1024px) {
  .text-box {
    flex-direction: column;
    height: 182px;
    margin-top: -3px;
  }
}

.text1 {
  width: 185px;
  font-size: 14px;
  font-weight: bold;
}
@media (max-width: 1024px) {
  .text1 {
    width: 83%;
    text-align: left;
    font-size: 14px;
    margin: 0 0 33px;
  }
}

.text2 {
  width: 185px;
  font-size: 14px;
  font-weight: bold;
}
@media (max-width: 1024px) {
  .text2 {
    width: 170px;
  }
}
@media (max-width: 1024px) {
  .text2 {
    width: 83%;
    text-align: left;
    font-size: 14px;
    margin: 0 0 33px;
  }
}

.text3 {
  width: 185px;
  font-size: 14px;
  font-weight: bold;
}
@media (max-width: 1024px) {
  .text3 {
    width: 150px;
  }
}
@media (max-width: 1024px) {
  .text3 {
    width: 83%;
    text-align: left;
    font-size: 14px;
    margin: 0 0 33px;
  }
}

.text4 {
  width: 185px;
  font-size: 14px;
  font-weight: bold;
}
@media (max-width: 1024px) {
  .text4 {
    width: 170px;
    margin-bottom: 15px;
  }
}
@media (max-width: 1024px) {
  .text4 {
    width: 83%;
    text-align: left;
    font-size: 14px;
    margin: 0 0 33px;
  }
}

.inline-labels {
  display: inline-block;
}

.tooltip-input {
  margin-left: -550px;
  position: relative !important;
}
@media (max-width: 1024px) {
  .tooltip-input {
    margin-left: 120px;
    position: relative !important;
  }
}

i.tooltip-icon {
  position: relative !important;
}
@media (max-width: 1024px) {
  i.tooltip-icon {
    position: relative !important;
  }
}

#AccesoriesPage {
  float: none;
  font-size: 17px;
}
@media (max-width: 1024px) {
  #AccesoriesPage {
    width: 100%;
    font-size: 14px;
  }
}

.Accessories-section {
  background: #F2FAFD;
  text-align: center;
  font-family: Omnes-ATT-W02;
  letter-spacing: 0.18px;
  color: #000000;
  opacity: 1;
  margin-top: 48px;
  padding-top: 48px !important;
  padding-bottom: 48px !important;
  padding-left: 40px;
  padding-right: 40px;
  margin-bottom: -20px;
}
@media (max-width: 1024px) {
  .Accessories-section {
    width: 100%;
    background: white;
    padding: 0px;
  }
}

.Accessories-section h2 {
  font-weight: bold;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  margin-bottom: 8px;
}
@media (max-width: 1024px) {
  .Accessories-section h2 {
    font-size: 19px;
  }
}

.Accessories-section img {
  width: 100%;
}

.imageContanier {
  margin-top: 40px;
  margin-bottom: 40px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
@media (max-width: 1024px) {
  .imageContanier {
    display: grid;
    grid-template-columns: 50px 50px 50px 50px 50px 50px 50px 50px;
    column-gap: 20px;
    overflow-x: scroll;
  }
}

.success-section {
  text-align: center;
  margin-bottom: 45px;
}
@media (max-width: 1024px) {
  .success-section {
    margin-bottom: 24px;
  }
}

.reg-heading {
  font-size: 24px;
  font-weight: 700;
  margin-bottom: 10px;
  font-family: "ATT Aleck Sans";
}
@media (max-width: 1024px) {
  .reg-heading {
    margin-bottom: 0px;
  }
}

@media (max-width: 1024px) {
  .left-section {
    margin-bottom: 26px;
    margin-left: 25%;
  }
}

.left-section h2 {
  font-weight: 700;
  margin-bottom: 8px;
  font-family: "ATT Aleck Sans";
}

@media (max-width: 1024px) {
  .left-section p {
    margin-bottom: 5px !important;
  }
}

.left-section h4 {
  font-weight: 400;
}

.expect-section {
  display: inline-flex;
}
@media (max-width: 1024px) {
  .expect-section {
    display: block;
  }
}

.left-icon img {
  width: 30px;
}

.left-icon {
  padding: 10px;
  background: #BAEEFC;
  width: 44px;
  border-radius: 20px;
}

.info-section {
  display: inline-flex;
}

.right-info {
  margin-left: 15px;
}

.right-section li {
  margin-bottom: 20px;
}
@media (max-width: 1024px) {
  .right-section li {
    margin-bottom: 35px;
  }
}

.continue-btn {
  border-radius: 42px;
  width: 112px;
  text-decoration: none !important;
  color: #fff;
  height: 32px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: var(--Controls-Button-Primary-Fill, #00388F);
  font-size: 14px;
}
@media (max-width: 1024px) {
  .continue-btn {
    width: 100px !important;
    margin-right: 10px !important;
    font-size: 11px !important;
  }
}

.image-content {
  font-family: "ATT Aleck Sans";
  position: absolute;
  margin-top: 8%;
  margin-left: 4%;
  font-size: 14px;
  width: 435px;
}
@media (max-width: 1024px) {
  .image-content {
    margin-top: 4%;
    font-size: 10px;
  }
}

@media (max-width: 1024px) {
  .image-content p {
    font-size: 10px;
    width: 214px;
    line-height: normal;
    margin-bottom: 8px !important;
  }
}

@media (max-width: 1024px) {
  .image-content h4 {
    font-family: "ATT Aleck Sans";
    font-size: 12px;
    margin-bottom: 8px !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/lib/ng2-sapmp/src/assets/style/mixinfunction.scss","webpack://./src/lib/ng2-sapmp/src/assets/style/variables.scss","webpack://./src/app/pages/signup-setup/confirm-signup-setup/confirm-signup-setup.component.scss"],"names":[],"mappings":"AAwBI;EA4BA;IACE,YClDE;ECAN;EFiDE;IACE,aClDE;ECGN;EF8CE;IACE,UClDE;ECMN;EF2CE;IACE,aClDE;ECSN;EFwCE;IACE,aClDE;ECYN;EFqCE;IACE,UClDE;ECeN;EFkCE;IACE,aClDE;ECkBN;EF+BE;IACE,aClDE;ECqBN;EF4BE;IACE,UClDE;ECwBN;EFyBE;IACE,aClDE;EC2BN;EFsBE;IACE,aClDE;EC8BN;EFmBE;IACE,WClDE;ECiCN;EFqBE;IACE,kBCvDE;ECoCN;EFkBE;IACE,mBCvDE;ECuCN;EFeE;IACE,gBCvDE;EC0CN;EFYE;IACE,mBCvDE;EC6CN;EFSE;IACE,mBCvDE;ECgDN;EFME;IACE,gBCvDE;ECmDN;EFGE;IACE,mBCvDE;ECsDN;EFAE;IACE,mBCvDE;ECyDN;EFHE;IACE,gBCvDE;EC4DN;EFNE;IACE,mBCvDE;EC+DN;EFTE;IACE,mBCvDE;ECkEN;EFZE;IACE,iBCvDE;ECqEN;AACF;AF7CI;EAoCA;IACE,YC9DE;EC0EN;EFbE;IACE,aC9DE;EC6EN;EFhBE;IACE,UC9DE;ECgFN;EFnBE;IACE,aC9DE;ECmFN;EFtBE;IACE,aC9DE;ECsFN;EFzBE;IACE,UC9DE;ECyFN;EF5BE;IACE,aC9DE;EC4FN;EF/BE;IACE,aC9DE;EC+FN;EFlCE;IACE,UC9DE;ECkGN;EFrCE;IACE,aC9DE;ECqGN;EFxCE;IACE,aC9DE;ECwGN;EF3CE;IACE,WC9DE;EC2GN;EFzCE;IACE,kBCnEE;EC8GN;EF5CE;IACE,mBCnEE;ECiHN;EF/CE;IACE,gBCnEE;ECoHN;EFlDE;IACE,mBCnEE;ECuHN;EFrDE;IACE,mBCnEE;EC0HN;EFxDE;IACE,gBCnEE;EC6HN;EF3DE;IACE,mBCnEE;ECgIN;EF9DE;IACE,mBCnEE;ECmIN;EFjEE;IACE,gBCnEE;ECsIN;EFpEE;IACE,mBCnEE;ECyIN;EFvEE;IACE,mBCnEE;EC4IN;EF1EE;IACE,iBCnEE;EC+IN;AACF;AAlJA;EACI,UAAA;EACA,gBAAA;AAoJJ;;AAlJA;EACI,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;AAqJJ;AApJI;EALJ;IAQQ,kBAAA;IACA,mBAAA;IACA,eAAA;EAqJN;AACF;;AAnJA;EACI,eAAA;EACA,cAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;AAsJJ;AArJI;EANJ;IAOQ,iBAAA;IACA,eAAA;EAwJN;AACF;;AAtJA;EACI,gBAAA;EACA,kBAAA;AAyJJ;;AAvJA;EACI,qBAAA;EACA,kBAAA;AA0JJ;AAzJI;EAHJ;IAIQ,mBAAA;IACA,kBAAA;EA4JN;AACF;;AA1JA;EACI,eAAA;EACA,cAAA;EACA,UAAA;EACA,mBAAA;AA6JJ;AA5JI;EALJ;IAMQ,iBAAA;EA+JN;AACF;;AA5JA;EACI,WAAA;EACA,mBAAA;AA+JJ;AA9JI;EAHJ;IAIQ,iBAAA;EAiKN;AACF;;AA/JA;EACI,gBAAA;EACA,kBAAA;AAkKJ;;AAxJA;EACI,WAAA;EACA,WAAA;EACA,cAAA;EACA,iBAAA;AA2JJ;AF7MI;EE8CJ;IAMQ,YAAA;EA6JN;AACF;;AA3JA;EACI,qBAAA;EACA,iBAAA;AA8JJ;AFvNI;EEuDJ;IAIQ,iBAAA;EAgKN;AACF;;AA9JA;EACI,eAAA;EACA,cAAA;EACA,UAAA;EACA,gBAAA;AAiKJ;AFnOI;EE8DJ;IAMI,WAAA;EAmKF;AACF;;AAjKA;EACI,eAAA;EACA,cAAA;EACA,UAAA;EACA,gBAAA;AAoKJ;AF/OI;EEuEJ;IAMI,eAAA;EAsKF;AACF;;AApKA;EACI,cAAA;EACA,iBAAA;EACA,eAAA;EACA,cAAA;EACA,UAAA;EACA,gBAAA;AAuKJ;;AArKA;EACI,WAAA;AAwKJ;;AAtKA;EACI,qBAAA;EACA,UAAA;AAyKJ;;AAvKA;EACI,mBAAA;AA0KJ;;AAxKA;EACI,eAAA;EACA,cAAA;EACA,UAAA;EACA,gBAAA;AA2KJ;AA1KI;EALJ;IAMQ,iBAAA;EA6KN;AACF;AFtRI;EEkGJ;IAUK,kBAAA;EA8KH;AACF;;AA5KA;EACI,eAAA;EACA,cAAA;EACA,UAAA;EACA,gBAAA;AA+KJ;;AA7KA;EAQI,cAAA;AAyKJ;AA/KI;EACI,iBAAA;AAiLR;AFzSI;EEuHA;IAGI,kBAAA;EAmLN;AACF;;AA/KA;EACI,gBAAA;EACA,yBAAA;AAkLJ;;AAhLA;EACI,6BAAA;AAmLJ;;AAjLA;EACI,eAAA;EACA,cAAA;EACA,UAAA;EACA,4BAAA;EACA,kBAAA;AAoLJ;;AAlLA;EACI,eAAA;EACA,cAAA;EACA,UAAA;EACA,0BAAA;EACA,kBAAA;AAqLJ;;AAnLA;EACI,4BAAA;AAsLJ;AF3UI;EEoJJ;IAIQ,uBAAA;EAuLN;AACF;;AArLA;EACI,YAAA;EACA,eAAA;EACA,YAAA;AAwLJ;AFtVI;EE2JJ;IAMQ,YAAA;EAyLN;AACF;AAxLQ;EARR;IAUQ,YAAA;EA0LN;AACF;;AAvLA;EACI,cAAA;EACA,mCAAA;EACA,iBAAA;EACA,YAAA;AA0LJ;;AAvLA;EACI,YAAA;EACA,eAAA;EACA,YAAA;AA0LJ;AF7WI;EEgLJ;IAKO,YAAA;EA4LL;AACF;;AA1LA;EACI,eAAA;EACA,cAAA;EACA,UAAA;EACA,WAAA;AA6LJ;;AA3LA;EACI,cAAA;EACA,eAAA;AA8LJ;;AA5LA;EACI,0BAAA;AA+LJ;;AA7LA;EACI,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;AAgMJ;;AA9LA;EACI,YAAA;AAiMJ;AF7YI;EE2MJ;IAGQ,aAAA;EAmMN;AACF;;AAhMA;EACI,YAAA;AAmMJ;AFtZI;EEkNJ;IAGQ,aAAA;EAqMN;AACF;;AAnMA;EACI,qBAAA;AAsMJ;;AAnMA;EACI,UAAA;EACA,WAAA;EACA,YAAA;EACA,+CAAA;EACA,UAAA;EACA,mBAAA;EACA,aAAA;AAsMJ;AApMI;EATJ;IAUQ,WAAA;EAuMN;AACF;;AAnMA;EACI,iBAAA;EACA,eAAA;EACA,kBAAA;EACA,0DAAA;EACA,sBAAA;EACA,cAAA;EACA,UAAA;AAsMJ;;AAnMA;EACI,kBAAA;AAsMJ;AApMI;EAHJ;IAIQ,qBAAA;EAuMN;AACF;;AAnMA;EACI,kBAAA;EACA,WAAA;EACA,kBAAA;EACA,cAAA;AAsMJ;AApMI;EANJ;IAOQ,uBAAA;IACA,gBAAA;EAuMN;AACF;AF9cI;EE8PJ;IAWQ,aAAA;IACA,mBAAA;IACA,YAAA;IACA,yBAAA;IACA,sBAAA;EAyMN;AACF;;AAtME;EACE,gBAAA;EACA,yBAAA;EACA,WAAA;EACA,aAAA;EACA,qBAAA;EACA,8BAAA;EACA,sCAAA;AAyMJ;AFjeI;EEiRF;IASM,sBAAA;IACA,6BAAA;IACA,YAAA;IACA,WAAA;EA2MN;AACF;;AAxME;EACE,iBAAA;EACA,kBAAA;EACA,kBAAA;AA2MJ;AF/eI;EEiSF;IAKM,aAAA;EA6MN;AACF;;AA1ME;EACE,aAAA;AA6MJ;;AA1ME;EACE,mBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,cAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,yBAAA;AA6MJ;AFrgBI;EE8SF;IAYM,WAAA;IACA,YAAA;IACA,eAAA;IACA,kBAAA;IACA,iBAAA;IACA,gBAAA;EA+MN;AACF;;AA7ME;EACE,WAAA;EACA,WAAA;EACA,WAAA;EACA,WAAA;EACA,yBAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;AAgNJ;AF1hBI;EEkUF;IAUM,aAAA;EAkNN;AACF;;AA/ME;EACE,kBAAA;EACA,aAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;AAkNJ;AFviBI;EEgVF;IAOM,aAAA;IACF,YAAA;IACA,kBAAA;IACA,iBAAA;EAoNJ;AACF;;AAlNE;EACE,WAAA;EACA,aAAA;EACA,qBAAA;EACA,8BAAA;EACA,sCAAA;EACA,kBAAA;EACA,gBAAA;AAqNJ;AAnNI;EATF;IAUM,YAAA;IACA,kBAAA;IACA,0BAAA;EAsNN;AACF;AFhkBI;EE6VF;IAgBM,sBAAA;IAEA,aAAA;IACA,gBAAA;EAsNN;AACF;;AApNE;EACE,YAAA;EACA,eAAA;EACA,iBAAA;AAuNJ;AF7kBI;EEmXF;IAKM,UAAA;IACA,gBAAA;IACA,eAAA;IACA,gBAAA;EAyNN;AACF;;AAvNE;EACE,YAAA;EACA,eAAA;EACA,iBAAA;AA0NJ;AAzNI;EAJF;IAKM,YAAA;EA4NN;AACF;AFhmBI;EE8XF;IAQM,UAAA;IACA,gBAAA;IACA,eAAA;IACA,gBAAA;EA8NN;AACF;;AA5NE;EACE,YAAA;EACA,eAAA;EACA,iBAAA;AA+NJ;AA9NI;EAJF;IAKM,YAAA;EAiON;AACF;AFnnBI;EE4YF;IAQM,UAAA;IACA,gBAAA;IACA,eAAA;IACA,gBAAA;EAmON;AACF;;AAjOE;EACE,YAAA;EACA,eAAA;EACA,iBAAA;AAoOJ;AAnOI;EAJF;IAKM,YAAA;IACA,mBAAA;EAsON;AACF;AFvoBI;EE0ZF;IASM,UAAA;IACA,gBAAA;IACA,eAAA;IACA,gBAAA;EAwON;AACF;;AArOE;EACE,qBAAA;AAwOJ;;AArOA;EACE,mBAAA;EACA,6BAAA;AAwOF;AFxpBI;EE8aJ;IAKM,kBAAA;IACA,6BAAA;EAyOJ;AACF;;AAtOA;EACE,6BAAA;AAyOF;AFlqBI;EEwbJ;IAIM,6BAAA;EA0OJ;AACF;;AAvOA;EACI,WAAA;EACA,eAAA;AA0OJ;AF5qBI;EEgcJ;IAIQ,WAAA;IACA,eAAA;EA4ON;AACF;;AA1OA;EACG,mBAAA;EACA,kBAAA;EACC,0BAAA;EACA,sBAAA;EACA,cAAA;EACA,UAAA;EACA,gBAAA;EACA,4BAAA;EACA,+BAAA;EACA,kBAAA;EACA,mBAAA;EACA,oBAAA;AA6OJ;AFjsBI;EEwcJ;IAcQ,WAAA;IACA,iBAAA;IACA,YAAA;EA+ON;AACF;;AA7OA;EACI,iBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;EACA,kBAAA;AAgPJ;AFjtBI;EE2dJ;IAQQ,eAAA;EAkPN;AACF;;AAhPA;EACI,WAAA;AAmPJ;;AAjPA;EACI,gBAAA;EACA,mBAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;AAoPJ;AFluBI;EEyeJ;IAOQ,aAAA;IACA,8DAAA;IACA,gBAAA;IACA,kBAAA;EAsPN;AACF;;AAnPA;EACI,kBAAA;EACA,mBAAA;AAsPJ;AF/uBI;EEufJ;IAIQ,mBAAA;EAwPN;AACF;;AArPA;EACI,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,6BAAA;AAwPJ;AF3vBI;EE+fJ;IAMQ,kBAAA;EA0PN;AACF;;AFhwBI;EE0gBJ;IAEQ,mBAAA;IACA,gBAAA;EAyPN;AACF;;AAtPA;EACI,gBAAA;EACA,kBAAA;EACA,6BAAA;AAyPJ;;AF7wBI;EEuhBJ;IAEQ,6BAAA;EAyPN;AACF;;AAtPA;EACI,gBAAA;AAyPJ;;AAtPA;EACI,oBAAA;AAyPJ;AF3xBI;EEiiBJ;IAGQ,cAAA;EA2PN;AACF;;AAxPA;EACI,WAAA;AA2PJ;;AAxPA;EACI,aAAA;EACA,mBAAA;EACA,WAAA;EAEA,mBAAA;AA0PJ;;AAvPA;EACI,oBAAA;AA0PJ;;AAvPA;EACI,iBAAA;AA0PJ;;AAvPA;EACI,mBAAA;AA0PJ;AFvzBI;EE4jBJ;IAGQ,mBAAA;EA4PN;AACF;;AAzPA;EACI,mBAAA;EACA,YAAA;EACA,gCAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,wDAAA;EACA,eAAA;AA4PJ;AFz0BI;EEmkBJ;IAYM,uBAAA;IACA,6BAAA;IACA,0BAAA;EA8PJ;AACF;;AA3PE;EACE,6BAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;EAEA,eAAA;EACA,YAAA;AA6PJ;AFz1BI;EEqlBF;IASM,cAAA;IACA,eAAA;EA+PN;AACF;;AF/1BI;EEomBF;IAEM,eAAA;IACA,YAAA;IACA,mBAAA;IACA,6BAAA;EA8PN;AACF;;AFx2BI;EE6mBF;IAEM,6BAAA;IACA,eAAA;IACA,6BAAA;EA8PN;AACF","sourcesContent":["@import 'variables';\n\n@function color($color-name, $color-variant: null) {\n  // color variant is optional\n  @if ($color-variant != null) {\n    // map inception\n    @return map-get(map-get($colors, $color-name), $color-variant);\n  }@else {\n    @return map-get($colors, $color-name);\n  }\n}\n// buttons building section\n\n$btns: (\n  default: color(default, base),\n  primary: color(primary, base),\n  secondary:  color(secondary, base),\n  inverse: color(inverse, light),\n  success: color(success, base),\n  danger:  color(danger, base)\n);\n\n@mixin respond-to($breakpoint) {\n  @if $breakpoint == 'small' {\n    @media (max-width: 1024px) {\n      @content;\n    }\n  }@else if $breakpoint == 'large' {\n    @media (min-width: 1025px) {\n      @content;\n    }\n  }\n}\n\n@mixin vendor-prefix($name, $value) {\n  @each $vendor in ('-webkit-', '-moz-', '-ms-', '-o-', '') {\n    #{$name}: #{$value};\n  }\n}\n\n\n@mixin placeholder() {\n  color: color(inverse, light) !important;\n  font-family: 'Omnes-ATT-W02-Italic'!important;\n  font-style: normal;\n  opacity: 1;\n  font-size: 16px;\n}\n\n// dynamic\n@include respond-to(small) {\n  @each $gridname, $gridvalue in $grids {\n    .col-sm-#{$gridname} {\n      width: $gridvalue;\n    }\n  }\n  @each $gridname, $gridvalue in $grids {\n    .col-sm-offset-#{$gridname} {\n      margin-left: $gridvalue;\n    }\n  }\n}\n@include respond-to (large) {\n  @each $gridname, $gridvalue in $grids {\n    .col-md-#{$gridname} {\n      width: $gridvalue;\n    }\n  }\n  @each $gridname, $gridvalue in $grids {\n    .col-md-offset-#{$gridname} {\n      margin-left: $gridvalue;\n    }\n  }\n}\n","// Global Variables\n@import './../../../../../assets/style/var-config';\n// grids here\n$grids: (\n  1: 8.33%,\n  2: 16.66%,\n  3: 25%,\n  4: 33.33%,\n  5: 41.66%,\n  6: 50%,\n  7: 58.33%,\n  8: 66.66%,\n  9: 75%,\n  10: 83.33%,\n  11: 91.66%,\n  12: 100%\n);\n\n\n// refer http://digitaldesign.web.att.com/getstarted-color.html\n$att-dark-blue: hsl(205, 94%, 35%); // #0568ae\n$f-red: hsl(0, 66%, 49%); // #cf2a2a Functional Red\n$fb-gray: hsl(0, 0%, 95%); // #f2f2f2 Functional background Gray\n$att-dark-gray: hsl(0, 0%, 35%); // #5a5a5a\n$f-green: hsl(150, 100%, 24%); // #007a3e functional Green\n// $att-orange: hsl(30, 100%, 46%); // #ea7400 ATT Orange\n$att-orange: #ea7400; //ATT Orange\n\n// set color map easy use variables\n$primary: $att-orange !default;\n$secondary: $att-dark-blue !default;\n$default: $fb-gray !default;\n$inverse: $att-dark-gray !default;\n$danger: $f-red !default;\n$success: $f-green !default;\n\n\n// color variable map\n$colors: (\n  info: #009fdb,\n  enrolledActive:  #66cc00,\n  enrolledNotActive: #70c5e9,\n  notEnrolled: #fdb91d,\n  outOfCompliance: #cccccc,\n  appleNotinstalled: #fcbb15, \n\n  // Primary - Blue color\n  primary: (\n    base: $primary,\n    light: lighten($primary, 15%),\n    lightest: lighten($primary, 60%),\n    dark: darken($primary, 15%)\n  ),\n\n  // Secondary - Orange color\n  secondary: (\n    base: $secondary,\n    light: lighten($secondary, 15%),\n    lightest: lighten($secondary, 60%),\n    dark: darken($secondary, 15%)\n  ),\n\n  // default - Gray color\n  default: (\n    base: $default,\n    light: lighten($default, 5%), // #fff white\n    dark: darken($default, 12.8%), // #d2d2d2 ATT Light Gray\n    darker: darken($default, 18%) // #c4c4c4\n  ),\n\n  // Inverse - Black color\n  inverse: (\n    base: $inverse,\n    light: lighten($inverse, 11.25%), // #767676 Auxiliary Gray\n    lightest: lighten($inverse, 25%), // #999999\n    lighter: lighten($inverse, 23.4%), // #959595 ATT Gray\n    dark: darken($inverse, 15%), // #333 ATT Dark Gray (2015)\n    darker: darken($inverse, 25.2%), // #191919 Functional Digital Text Black\n    darkest: darken($inverse, 35%) // #000 \n  ),\n\n  // danger - Red color\n  danger: (\n    base: $danger,\n    light: lighten($danger, 15%),\n    dark: darken($danger, 15%)\n  ),\n\n  // success - Green color\n  success: (\n    base: $success,\n    light: lighten($success, 15%),\n    dark: darken($success, 15%)\n  )\n);\n","@import '../../../../lib/ng2-sapmp/src/assets/style/mixinfunction';\n.step-indicator {\n    width: 80%;\n    margin-left: 10%;\n}\n.main-div {\n    margin-left: 18%;\n    margin-right: 18%;\n    margin-bottom: 20px;\n    margin-top: 40px;\n    @media(max-width: 1024px) {\n        // margin-left: 12.25%;\n        // margin-right: 12.25%;\n        margin-left: 2.25%;\n        margin-right: 2.25%;\n        margin-top: 20%;\n    }\n}\n.confirm-heading {\n    font-size: 32px;\n    color: #000000;\n    opacity: 1;\n    float: left;\n    margin-bottom: 0px;\n    @media(max-width: 1024px) {\n        line-height: 30px;\n        font-size: 30px;\n    }\n}\n.confirm-subheading {\n    margin-top: 20px;\n    margin-bottom: 5px;\n}\n.inline-success {\n    display: inline-block;\n    margin-right: 10px;\n    @media (max-width: 1024px) {\n        display: table-cell;\n        margin-right: 15px;\n    }\n}\n.success-message {\n    font-size: 24px;\n    color: #067a3e;\n    opacity: 1;\n    margin-bottom: 10px;\n    @media (max-width: 1024px) {\n        line-height: 25px;\n    }\n\n}\n.success-img {\n    width: 60px;\n    margin-bottom: 30px;\n    @media (min-width: 1025px) {\n        margin-top: -20px;\n    }\n}\n.success-description {\n    margin-top: -6px;\n    margin-bottom: 0px;\n    // margin-left: 59px;\n}\n// .success-section {\n//     margin-bottom: 20px;\n//     width: 100%;\n//     @include respond-to('small') {\n//         margin-left: -40px;\n//     }\n// }\n.confirm-info {\n    width: 100%;\n    float: left;\n    margin-top: 2%;\n    margin-bottom: 2%;\n    @include respond-to('small') {\n        width: 325px;\n    }\n}\n.confirm-blocks {\n    display: inline-block;\n    margin-right: 10%;\n    @include respond-to('small') {\n        margin-right: 9px;\n    }\n}\n.confirm-block-heading {\n    font-size: 16px;\n    color: #000000;\n    opacity: 1;\n    text-align: left;\n    @include respond-to('small') {\n    width: 90px;\n    }\n}\n.confirm-block-value {\n    font-size: 24px;\n    color: #000000;\n    opacity: 1;\n    text-align: left;\n    @include respond-to('small') {\n    font-size: 16px;\n    }\n}\n.contact-heading {\n    margin-top: 2%;\n    margin-bottom: 2%;\n    font-size: 24px;\n    color: #000000;\n    opacity: 1;\n    text-align: left;\n}\n.contact-section {\n    width: 100%;\n}\n.added-links {\n    display: inline-block;\n    width: 40%;\n}\n.contact-fields {\n    margin-bottom: 10px;\n}\n.prod-heading {\n    font-size: 24px;\n    color: #000000;\n    opacity: 1;\n    text-align: left;\n    @media(max-width: 1024px) {\n        line-height: 25px;\n    }\n    \n    @include respond-to('small') {\n     margin-left: -30px;   \n    }\n}\n.notification-heading {\n    font-size: 24px;\n    color: #000000;\n    opacity: 1;\n    text-align: left;\n}\n.notification-section, .prod-section {\n    \n    p {\n        margin-left: 15px;\n        @include respond-to('small') {\n        margin-left: -30px ;\n        }\n    }\n    margin-top: 2%;\n}\n.acknowledgement-sub-section {\n    display: flexbox;\n    background-color: #f2f2f2;\n}\n.acknowledgement-section {\n    background-color: transparent;\n}\n.acknowledgement-heading {\n    font-size: 24px;\n    color: #000000;\n    opacity: 1;\n    padding: 15px 15px 15px 15px;\n    margin-bottom: 0px;\n}\n.acknowledgement-description {\n    font-size: 16px;\n    color: #000000;\n    opacity: 1;\n    padding: 5px 15px 5px 15px;\n    margin-bottom: 0px;\n}\n.confirm-section {\n    padding: 15px 15px 15px 15px;\n    @include respond-to('small') {\n    // margin-left: -45px;\n        padding: 0px !important;\n    }\n}\n#requestEnrollment {\n    float: right;\n    font-size: 17px;\n    margin: 12px;\n    @include respond-to('small') {\n       // margin-right: 35px;\n        width: 235px;\n        }\n        @media screen and (min-device-width : 414px) and (max-device-width : 736px) {\n        // margin-right: 35px;\n        width: 265px;\n          }\n}\n//added for accessories defect 667(CTA design)\n.requestEnrollment{\n    color:#087ac2;\n    font: 1.9rem \"Omnes-ATT-W02-Medium\";\n    background:white;\n    border:none;\n}\n\n#gotoApple {\n    float: right;\n    font-size: 17px;\n    margin: 12px;\n    @include respond-to('small') {\n       height: 55px;\n        }\n}\n.confirm-subheading {\n    font-size: 16px;\n    color: #000000;\n    opacity: 1;\n    float: left;\n}\na {\n    color: #1483d9;\n    cursor: pointer;\n}\na:hover {\n    text-decoration: underline;\n}\n#cancel-link {\n    float: right;\n    margin-right: 20px;\n    margin-top: 15px;\n    font-size: 18px;\n}\n.submit-section {\n    height: 50px;\n    @include respond-to('small') {\n        height: 115px;\n    }\n}\n//added for accessories defect 667\n.submit-section01 {\n    height: 50px;\n    @include respond-to('small') {\n        height: 17rem;\n    }\n}\n.labels-inline {\n    display: inline-block;\n}\n\n.greybox {\n    top: 469px;\n    left: 215px;\n    width: 945px;\n    background: #F2F2F2 0% 0% no-repeat padding-box;\n    opacity: 1;\n    margin-bottom: 50px;\n    padding: 15px;\n\n    @media(max-width: 1024px) {\n        width: 100%;\n        // height: 370px;\n    }\n}\n\n.noteheading {\n    font-weight: bold;\n    font-size: 21px;\n    text-align: center;\n    font-family: normal normal medium 22px/21px ATT Aleck Sans;\n    letter-spacing: 0.18px;\n    color: #000000;\n    opacity: 1;\n}\n\n.notetext {\n    text-align: center;\n\n    @media(max-width: 1024px) {\n        word-wrap: break-word;\n    }\n\n}\n\n.content-wrapper {\n    position: relative;\n    width: auto;\n    padding: 15px 80px;\n    margin: 0 auto;\n    \n    @media(max-width: 1024px) {\n        width: 230px !important;\n        margin-left: 0px;\n    }\n    @include respond-to('small') {\n        display:flex;\n        flex-direction: row;\n        padding: 0px;\n        margin: 0 auto !important;\n        width: 100% !important;\n      }\n  }\n  \n  .ng-modal-number-container {\n    margin-top: 25px;\n    background-color:#f1f2f3;\n    width:auto;\n    display:flex;\n    display: -webkit-flex;\n    justify-content: space-between;\n    -webkit-justify-content: space-between;\n    @include respond-to('small') {\n        flex-direction: column;\n        border-top: 0px solid #1483d9;\n        height: auto;\n        width: 100%;\n      }\n  }\n  \n  .numberContainer {\n    margin-top: -23px;\n    position: relative;\n    text-align: center;\n    @include respond-to('small') {\n        display: flex;\n    }\n  }\n\n  .ng-modal-number-container .numberContainer:last-child .numberIcon::after {\n    display: none;\n  }\n  \n  .numberIcon {\n    margin: 0 auto 10px;\n    width:45px;\n    height:45px;\n    border-radius:50%;\n    font-size:18px;\n    color:#f1f2f3;\n    line-height:42px;\n    text-align:center;\n    background:#1483d9;\n    border:2px solid #1483d9;\n    @include respond-to('small') {\n        width:32px;\n        height:32px;\n        font-size:16px;\n        text-align:center;\n        line-height:32px;\n        margin-left: 0px;\n      }\n  }\n  .numberIcon::after {\n    content: \"\";\n    float: left;\n    width: 100%;\n    height: 4px;\n    background-color: #1483d9;\n    position: absolute;\n    top: 19px;\n    right: auto;\n    @include respond-to('small') {\n        display: none;\n    }\n  }\n\n  .content-text{\n    position: relative;\n    height: 185px;\n    width: 630px;\n    text-align: center;\n    font-weight: bold;\n    @include respond-to('small'){ \n        height: 185px;\n      width: 325px;\n      text-align: center;\n      font-weight: bold;\n      }\n  }\n  .text-box{\n    width:auto;\n    display:flex;\n    display: -webkit-flex;\n    justify-content: space-between;\n    -webkit-justify-content: space-between;\n    margin-left: -70px;\n    margin-top: 10px;\n\n    @media(max-width: 1024px) {\n        width: 220px;\n        margin-left: -50px;\n        margin: 20px 10px 10px 2px;\n    }\n    @include respond-to('small') {\n        //width: fit-content;\n        flex-direction: column;\n        //margin: 20px;\n        height: 182px;\n        margin-top: -3px;\n      }\n  }\n  .text1{\n    width:185px;\n    font-size:14px;\n    font-weight: bold;\n    @include respond-to('small') { \n        width:83%;\n        text-align: left;\n        font-size:14px;\n        margin: 0 0 33px;\n      }\n  }\n  .text2{\n    width:185px;\n    font-size:14px;\n    font-weight: bold;\n    @media(max-width: 1024px) {\n        width: 170px;\n    }\n    @include respond-to('small') { \n        width:83%;\n        text-align: left;\n        font-size:14px;\n        margin: 0 0 33px;\n    }\n  }\n  .text3{\n    width:185px;\n    font-size:14px;\n    font-weight: bold;\n    @media(max-width: 1024px) {\n        width: 150px;\n    }\n    @include respond-to('small') { \n        width:83%;\n        text-align: left;\n        font-size:14px;\n        margin: 0 0 33px;\n    }  \n  }\n  .text4{\n    width:185px;\n    font-size:14px;\n    font-weight: bold;\n    @media(max-width: 1024px) {\n        width: 170px;\n        margin-bottom: 15px;\n    }\n    @include respond-to('small') { \n        width:83%;\n        text-align: left;\n        font-size:14px;\n        margin: 0 0 33px;\n    }\n  }\n\n  .inline-labels {\n    display: inline-block;\n}\n\n.tooltip-input {\n  margin-left: -550px;\n  position: relative !important;\n\n  @include respond-to('small') {\n      margin-left: 120px;\n      position: relative !important;\n  }\n}\n\ni.tooltip-icon {\n  position: relative !important;\n\n  @include respond-to('small') {\n      position: relative !important;\n  }\n}\n// added for mobile view and desktop view of accessories button(CTA design)\n#AccesoriesPage {\n    float: none;\n    font-size: 17px;\n    @include respond-to('small') {\n        width: 100%;\n        font-size: 14px;\n    }\n}\n.Accessories-section{\n   background: #F2FAFD;\n   text-align: center;\n    font-family: Omnes-ATT-W02;\n    letter-spacing: 0.18px;\n    color: #000000;\n    opacity: 1;\n    margin-top: 48px;\n    padding-top: 48px !important;\n    padding-bottom: 48px !important;\n    padding-left: 40px;\n    padding-right: 40px;\n    margin-bottom: -20px;\n    @include respond-to('small') {\n        width: 100%;\n        background:white;\n        padding: 0px;\n    } \n}\n.Accessories-section h2{\n    font-weight: bold;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 100%;\n    margin-bottom: 8px;\n    @include respond-to('small') {\n        font-size:19px;\n    }\n}\n.Accessories-section img{\n    width: 100%;\n}\n.imageContanier{\n    margin-top: 40px;\n    margin-bottom: 40px;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    @include respond-to('small') {\n        display: grid;\n        grid-template-columns:  50px 50px 50px 50px 50px 50px 50px 50px;\n        column-gap: 20px;\n        overflow-x: scroll;\n    }   \n}\n\n.success-section{\n    text-align: center;\n    margin-bottom: 45px;\n    @include respond-to('small') {\n        margin-bottom: 24px;\n    }\n}\n\n.reg-heading{\n    font-size: 24px;\n    font-weight: 700;\n    margin-bottom: 10px;\n    font-family: 'ATT Aleck Sans';\n    @include respond-to('small') {\n        margin-bottom: 0px;\n    }\n\n}\n\n.left-section{\n    @include respond-to('small') {\n        margin-bottom: 26px;\n        margin-left: 25%;\n    }\n}\n\n.left-section h2{\n    font-weight: 700;\n    margin-bottom: 8px;\n    font-family: 'ATT Aleck Sans';\n}\n\n.left-section p{\n    @include respond-to('small') {\n        margin-bottom: 5px !important;\n    }\n}\n\n.left-section h4{\n    font-weight: 400;\n}\n\n.expect-section{\n    display: inline-flex;\n    @include respond-to('small') {\n        display: block;\n    } \n}\n\n.left-icon img{\n    width:30px;\n}\n\n.left-icon{\n    padding: 10px;\n    background: #BAEEFC;\n    width: 44px;\n    // height: 40px;\n    border-radius: 20px;\n}\n\n.info-section{\n    display:inline-flex;\n}\n\n.right-info{\n    margin-left: 15px;\n}\n\n.right-section li{\n    margin-bottom: 20px;\n    @include respond-to('small') {\n        margin-bottom: 35px;\n    } \n}\n\n.continue-btn {\n    border-radius: 42px;\n    width: 112px;\n    text-decoration: none !important;\n    color:#fff;\n    height: 32px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    background: var(--Controls-Button-Primary-Fill, #00388F);\n    font-size: 14px;\n    @include respond-to('small') {\n      width: 100px !important;\n      margin-right: 10px !important;\n      font-size:11px !important;\n    }\n  }\n\n  .image-content{\n    font-family: 'ATT Aleck Sans';\n    position: absolute;\n    margin-top: 8%;\n    margin-left: 4%;\n    // z-index: 99999;\n    font-size: 14px;\n    width: 435px;\n    @include respond-to('small') {\n        margin-top: 4%;\n        font-size: 10px;\n      }\n    \n  }\n\n  .image-content p{\n    @include respond-to('small') {\n        font-size: 10px;\n        width: 214px;\n        line-height: normal;\n        margin-bottom: 8px !important;\n    }\n  }\n\n  .image-content h4{\n    @include respond-to('small') {\n        font-family: 'ATT Aleck Sans';\n        font-size: 12px;\n        margin-bottom: 8px !important;\n    }\n  }"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
